import React from "react";
import { Link } from "react-router-dom";
import { Section } from "../elements/bodyComponents";
import { ShuffleArray } from "../helpers/helpers";
import { Button } from "../elements/buttons";
import { SectionTitle } from "../typography/typography";
import { ProductCard } from "../layouts/allProducts";

//DATA
import { Products } from "../json/products";

/*
    PRODUCT PROMO - used to display a few products
*/
export class ProductsPromo extends React.Component {
  constructor(props) {
    super(props);

    this.getProducts = this.getProducts.bind(this);
    this.state = {
      products: this.getProducts(this.props)
    };
  }

  getProducts(props) {
    //console.log( 'get recipes for', this.props.category );
    let products = Products[props.category].items;

    //if generating related recipes remove current recipe from options
    if (typeof props.currentProduct !== "undefined") {
      console.log(
        "removing",
        props.currentProduct,
        "from the possible options"
      );
      products = products.filter(p => p.id !== props.currentProduct);
    }

    //if greater than max number - reduce
    if (products.length > props.max) {
      let shuffledArray = ShuffleArray(products);
      products = shuffledArray.slice(0, props.max);
    }

    return this.buildProductCards(products);
  }

  /*
        Build Card Components
        called by getRecipes after recipes are determined.
    */
  buildProductCards(products) {
    return products.map(p => (
      <ProductCard
        key={p.id}
        flip={false}
        type={this.props.category}
        color={this.props.color}
        id={p.id}
        title={p.name}
        description={p.description}
        image={p.image}
        buttonType="text"
      />
    ));
  }

  /*
        called when new params are passed to the component, like changing between recipes
    */
  componentWillReceiveProps(nextProps) {
    this.setState({
      products: this.getProducts(nextProps)
    });
  }

  render() {
    console.log(this.props.category);

    let classes = this.props.classes;
    if (typeof classes === "undefined") {
      classes = "";
    }

    return (
      <Section
        classes={`productPromo gridStyle-layout padding-y-xlarge ${classes}`}
      >
        {this.props.title !== "undefined" && (
          <SectionTitle classes="recipesPromo-title text-align-center margin-bottom-medium">
            <span>{this.props.title}</span>
          </SectionTitle>
        )}
        <div className="section-inner flex">{this.state.products}</div>
        <div className="section-actions text-align-center margin-top-large">
          <Link
            to={this.props.URL}
            data-section={this.props.category}
            data-subsection={this.props.category}
            data-pagetype={"Collection"}
          >
            <Button
              classes="primary"
              color={this.props.color}
              text={`All ${this.props.category}`}
            />
          </Link>
        </div>
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/products.js